import { create } from 'zustand';
import { hasLoggedInTimestamp, readLoginSnapshot, type LoginSnapshot } from './cookies/loginState';

function toAuthState(snapshot: LoginSnapshot | null, loggedInTimestampPresent = hasLoggedInTimestamp()) {
  return {
    isLoggedIn: snapshot !== null || loggedInTimestampPresent,
    loginSnapshot: snapshot,
  };
}

export interface AuthState {
  isLoggedIn: boolean;
  loginSnapshot: LoginSnapshot | null;
  setLoginSnapshot: (snapshot: LoginSnapshot | null, loggedInTimestampPresent?: boolean) => void;
}

export const useAuthStore = create<AuthState>()((set) => {
  const snapshot = readLoginSnapshot();

  return {
    ...toAuthState(snapshot),
    setLoginSnapshot: (nextSnapshot, loggedInTimestampPresent) => {
      set(toAuthState(nextSnapshot, loggedInTimestampPresent));
    },
  };
});
